import ScrollMagic from 'scrollmagic';

$(() => {

    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '.l-page__header',
        offset: 50,
        reverse: false
    })
    .setClassToggle('.l-page__header .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__customization-subdomain',
        triggerHook: 0.95,
        reverse: false
    })
    .setClassToggle('.l-page__customization-subdomain .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__customization-info',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-page__customization-info .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__customization-branding-pos',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-page__customization-branding-pos .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__customization-api',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-page__customization-api .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__customization-branding-pay',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-page__customization-branding-pay .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__analytics-other-technologies',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-page__analytics-other-technologies .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__get-now',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-page__get-now .js-animate', 'js-animate-loaded')
    .addTo(controller);


});



// WEBPACK FOOTER //
// ./app/scripts/pages/technologies/customization.js